angular.module('dpw.components')
    .directive('dpwCarousel', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            scope: true,
            replace: true,
            templateUrl: 'dpw-carousel.html',
            controller: ['$scope', function ($scope) {
                $scope.srcType = function (src) {
                    if (angular.isObject(src)) {
                        return 'file';
                    }
                    return (src && /(youtu\.be|youtube\.com)/i.test(src)) ? 'video' : 'image';
                };
            }],
            link: function (scope, elem) {
                // Make some styles customization based on how many screenshots/videos totally
                var totalItems = scope.resources.length;
                var $indicator = angular.element(_.first(elem.find('.dpw-carousel-indicator-dotty')));
                var indicatorSize = $indicator.width();
                var indicatorSpace = 20;
                var indicatorsAreaHeight = 60;
                var contentHeight = scope.carouselHeight - indicatorsAreaHeight + 'px';
                elem.height(scope.carouselHeight);
                scope.styles = {
                    scroller: {
                        width: totalItems * 100 + '%',
                        bottom: indicatorsAreaHeight,
                        height: contentHeight
                    },
                    slide: {
                        width: 100 / totalItems + '%',
                        height: contentHeight
                    },
                    indicator: {
                        width: (indicatorSize + indicatorSpace) * totalItems - indicatorSpace,
                        display: totalItems > 1 ? 'block' : 'none'
                    },
                    resource: {
                        "max-width": elem.width() + 'px',
                        "max-height": contentHeight
                    }
                };

                // Important to $timeout: waiting for the `ng-style` to take affect.
                $timeout(function () {
                    var carousel = new IScroll('.dpw-carousel', {
                        scrollX: true,
                        scrollY: true,
                        momentum: true,
                        snap: true,
                        snapSpeed: 500,
                        keyBindings: true,
                        indicators: {
                            el: '.dpw-carousel .dpw-carousel-indicator',
                            resize: false
                        }
                    });
                    scope.goToPage = function (pageNo) {
                        carousel.goToPage(pageNo, 0, 500);
                    };
                    $timeout(function () {
                        totalItems > 0 && scope.goToPage(scope.currentPage || 0);
                    }, 100);
                });
            }
        };
    }]);